import React from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { Link } from 'react-router-dom'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faList } from '@fortawesome/free-solid-svg-icons'
import clsx from 'clsx'

import DateFormat from '../../utils/dateFormat'
import Sites from '../Sites'
import CheckboxToggle from '../../utils/CheckboxToggleRemix'
import { updateAvailabilityRequest } from '../../../actions/availabilityRequestsActions'
import Skeleton from 'react-loading-skeleton'

const Show = ({ match }) => {
  const dispatch = useDispatch()
  const ar = useSelector(store => store.availabilityRequests.request)
  const fetching = useSelector(store => store.availabilityRequests.fetching)

  const toggleSms = () => dispatch(updateAvailabilityRequest(ar.uuid, { notify_sms: !ar.notifySms }))
  const toggleEmail = () => dispatch(updateAvailabilityRequest(ar.uuid, { notify_email: !ar.notifyEmail }))
  // const toggleWeb = () => dispatch(updateAvailabilityRequest(ar.uuid, { notify_web: !ar.notifyWeb }))

  const MetaWrapper = ({ children }) => <div className="">{children}</div>
  const MetaHeader = ({ children }) => <div className="tracking-wide text-sm text-gray-400">{children}</div>
  const MetaDetail = ({ children, width }) => <div className="text-xl">{!fetching ? children : <Skeleton width={width} />}</div>
  const StatsValue = ({ children, width }) => <div className="text-xl md:text-3xl lg:text-4xl">{!fetching ? children : <Skeleton width={width} />}</div>

  return (
    <div className={clsx('grid grid-flow-col gap-y-2 gap-x-4 grid-rows-4')}>
      <MetaWrapper>
        <MetaHeader>Checked Count</MetaHeader>
        <StatsValue width='2ch'>{ar.checkedCount}</StatsValue>
      </MetaWrapper>

      <MetaWrapper>
        <MetaHeader>Arriving between</MetaHeader>
        <MetaDetail width='20ch'>
          <DateFormat format="MM/DD/YYYY" date={ar.dateStart} /> & <DateFormat format="MM/DD/YYYY" date={ar.dateEnd} />
        </MetaDetail>
      </MetaWrapper>

      <MetaWrapper>
        <MetaHeader>Stay Length</MetaHeader>
        <MetaDetail width='2ch'>{ar.stayLength}+ nights</MetaDetail>
      </MetaWrapper>

      <MetaWrapper>
        <MetaHeader>Preferences</MetaHeader>
        <MetaDetail width='16ch' className="flex">
          {ar.premium && <CheckboxToggle label="SMS Notifications" checked={ar.notifySms} onChange={toggleSms} />}
          {ar.premium && <CheckboxToggle label="Email Notifications" checked={ar.notifyEmail} onChange={toggleEmail} />}
        </MetaDetail>
      </MetaWrapper>

      <MetaWrapper>
        <MetaHeader>Last Checked</MetaHeader>
        <StatsValue width='16ch'>
          <Link to={`/logs/${ar.facility.id}`}>
            {ar.checkedAt && <DateFormat format="M/D/YYYY hh:mm" date={ar.checkedAt} />}
            {!ar.checkedAt && <span>----</span>}

            <FontAwesomeIcon icon={faList} className="ml-4 text-gray-500 text-sm" />
          </Link>
        </StatsValue>
      </MetaWrapper>

      <MetaWrapper>
        <MetaHeader>Filters</MetaHeader>
        <MetaDetail width='20ch'>{ar.summary}</MetaDetail>
      </MetaWrapper>

      <MetaWrapper>
        <MetaHeader>Matching Sites Count</MetaHeader>
        <MetaDetail width='3ch'>
          {ar.siteCount} {ar.siteCount > 0 && <Sites />}
        </MetaDetail>
      </MetaWrapper>

      <MetaWrapper>
        <MetaHeader>Status</MetaHeader>
        <MetaDetail width='16ch'>
          <span className="capitalize">{ar.status}</span>
        </MetaDetail>
      </MetaWrapper>
    </div>
  )
}

export default Show

{
  /* <MetaWrapper>
<MetaHeader>Status</MetaHeader>
<MetaDetail>
  <span className="capitalize">{ar.status}</span>
</MetaDetail>
</MetaWrapper>

<Status /> */
}

// <MetaWrapper>
// <MetaHeader>Checked Count</MetaHeader>
// <MetaDetail>{ar.checkedCount}</MetaDetail>
// </MetaWrapper>

// <MetaWrapper>
// <MetaHeader>Last Checked</MetaHeader>
// <MetaDetail>
//   {ar.checked_at && <DateFormat format="M/D/YYYY hh:mm" date={ar.checkedAt} />} (
//   <Link to={`/logs/${facility.id}`}>Log</Link>)
// </MetaDetail>
// </MetaWrapper>
